import {Injectable} from '@angular/core';
import {DateTime} from 'luxon';

export type CostDocRequest = {
    costGroups: {
        costGroupId: string | null;
        webBillCostGroupId: string | null;
        disabled: boolean;
        groupNo: number | null;
        groupName: string;
        costSpecifications: {
            wbCostSpecificationId: string | null;
            amount: number | null;
            consumptionAmount: number | null;
            consumptionCost: boolean;
            consumptionUnit: string | null;
            vat: string | null;
            description: string;
            calculatedByBrunata: boolean;
            deleted: boolean;
        }[];
    }[];
    billMessageFromCustomer: string | null;
    billMessageOutstanding: string | null;
    billMessageRefund: string | null;
    contactPerson: string;
    contactEmail: string;
    contactPhoneNo: string;
    costReceivedDate: DateTime | null;
    noteToBrunata: string | null;
};

@Injectable({
    providedIn: 'root',
})
export class CostDocRequestAdapter {
    toApiModel(item: CostDocRequest): any {
        return {
            costGroups: item.costGroups.map(costGroup => ({
                groupNo: costGroup.groupNo,
                groupName: costGroup.groupName,
                costGroupId: costGroup.costGroupId,
                wbCostGroupId: costGroup.webBillCostGroupId,
                disabled: costGroup.disabled,
                costSpecifications: costGroup.costSpecifications.map(costSpecification => ({
                    // TODO: Why does the webservice have this extra "costSpecification" level?
                    costSpecification: {
                        wbCostSpecificationId: costSpecification.wbCostSpecificationId,
                        amount: costSpecification.amount,
                        consumptionAmount: costSpecification.consumptionAmount,
                        consumptionCost: costSpecification.consumptionCost,
                        consumptionUnit: costSpecification.consumptionUnit,
                        vat: costSpecification.vat,
                        description: costSpecification.description,
                        calculatedByBrunata: costSpecification.calculatedByBrunata,
                        deleted: costSpecification.deleted,
                    },
                })),
            })),
            billMessageOutstanding: item.billMessageOutstanding,
            billMessageRefund: item.billMessageRefund,
            contactPerson: item.contactPerson,
            contactEmail: item.contactEmail,
            contactPhoneNo: item.contactPhoneNo,
            costReceivedDate: item.costReceivedDate?.toISO(),
            noteToBrunata: item.noteToBrunata,
            billMessageFromCustomer: item.billMessageFromCustomer,
        };
    }
}
